"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    en: {
        Default: require('./Default.en').default
    },
    bg: {
        Default: require('./Default.bg').default
    },
    cy: {
        Default: require('./Default.cy').default
    },
    de: {
        Default: require('./Default.de').default
    },
    es: {
        Default: require('./Default.es').default
    },
    fi: {
        Default: require('./Default.fi').default
    },
    fr: {
        Default: require('./Default.fr').default
    },
    hu: {
        Default: require('./Default.hu').default
    },
    is: {
        Default: require('./Default.is').default
    },
    it: {
        Default: require('./Default.it').default
    },
    lt: {
        Default: require('./Default.lt').default
    },
    nb: {
        Default: require('./Default.nb').default
    },
    pl: {
        Default: require('./Default.pl').default
    },
    pt: {
        Default: require('./Default.pt').default
    },
    ro: {
        Default: require('./Default.ro').default
    },
    ru: {
        Default: require('./Default.ru').default
    },
    sv: {
        Default: require('./Default.sv').default
    },
    nl: {
        Default: require('./Default.nl').default
    }
};
